/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Tue Feb 09 2021 09:30:20 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { request } from '../utils/request';
import { API_URLS } from '../utils/config';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.SCORING;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface AttColumns {
  column: string;
  label: string;
  parcode: string;
  parlist: Array<ParList>;
  type: string;
  width: string;
}

export interface ConfigParScoring {
  applicationrule: string;
  parScoringDecLevels: Array<ConfigParScoringDecLevel>;
  parScoringDecisions: Array<ConfigParScoringDecision>;
  parScoringTabs: Array<ConfigParScoringTabs>;
  scoexecutionmode: string;
  scoid: number;
  scolabel: string;
  scoobjecttype: string;
  scostatus: string;
  scostatusdate: string;
  scostatususerid: number;
}

export interface ConfigParScoringDecLevel {
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisionlevelrule: string;
  scodeclevelid: number;
}

export interface ConfigParScoringDecision {
  existrefuse: string;
  notemax: number;
  notemin: number;
  scodecid: number;
  scodecisioncode: string;
  scodecisionlabel: string;
  scodecisionscore: string;
}
export interface ConfigParScoringTabs {
  displaymode: string;
  flagtapuse: boolean;
  parScoringAttributes: Array<ConfigParScoringAttribute>;
  tabid: number;
  tablabel: string;
  taborder: number;
}

export interface ConfigParScoringAttribute {
  actiontype: string;
  applicationrule: string;
  attcode: string;
  flagdisplay: boolean;
  parScoringAttEvals: Array<ConfigParScoringAttEval>;
  scoid: number;
  scolineid: number;
  scolinelabel: string;
  scolineorder: number;
}

export interface ConfigParScoringAttEval {
  attdecision: string;
  attdecisioncomment: string;
  attdecisionlabel: string;
  attevaloperand: string;
  attnote: number;
  evallist: string;
  evalmax: string;
  evalmin: string;
  scoevalid: number;
}

export interface ParList {
  id: number;
  lancode: string;
  mgid: number;
  parcode: string;
  parflagdefault: boolean;
  parlistlabel: string;
  parmodule: string;
  parvalue: string;
  parvalueparent: string;
}

export interface ParScoAttribute {
  attcode: string;
  attdataorigin: string;
  attevaluationmode: string;
  attformula: string;
  colspan: number;
  attinputcolor: string;
  attinputformat: string;
  attinputhint: string;
  attinputrows: string;
  attinputtype: string;
  attinputwidth: string;
  attlabel: string;
  attparcode: string;
  attserviceexecmode: string;
  attservicename: string;
  attservicewaittime: number;
  attvaluedatatype: string;
  attvaluejsonschema: string;
  flagaddline: boolean;
  flagdeleteline: boolean;
  flagupdate: boolean;
  flagupdatetabcolumn: boolean;
  objecttype: string;
  sqlfunction: string;
  sqlupdatefunction: string;
  tabcolumn: string;
  tabkey: string;
  tabtable: string;
  tabwhere: string;
}

export interface ParScoring {
  applicationrule: string;
  scoexecutionmode: string;
  scoid: number;
  scolabel: string;
  scoobjecttype: string;
  scostatus: string;
  scostatusdate: string;
  scostatususerid: number;
}

export interface ScoringAttributeListView {
  dateend: string;
  datestart: string;
  number1: number;
  number2: number;
  number3: number;
  number4: number;
  number5: number;
  number6: number;
  parcode1: string;
  parcode2: string;
  parcode3: string;
  scoid: number;
  scolineid: number;
  scolinelistid: number;
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  text5: string;
  text6: string;
}

export interface ScoringAttributeResponse {
  actiontype: string;
  attcode: string;
  attdecision: string;
  attdecisionlabel: string;
  attnote: number;
  attvalue: string;
  attvaluetype: string;
  flagdisplay: boolean;
  parAttribute: ParScoAttribute;
  parList: Array<ParList>;
  scoid: number;
  scolineid: number;
  scolineorder: number;
  scoringAttributeLists: Array<ScoringAttributeListView>;
  tabid: number;
  tablecolumns: Array<AttColumns>;
}

export interface ScoringFile {
  analystname: string;
  created_at: string;
  created_by: number;
  scorequestedamount: number;
  scoapprouvedamount: number;
  scocalculatedamount: number;
  currcode: string;
  objectid: number;
  objectreference: string;
  objecttype: string;
  scoanalystopinion: string;
  scoanalystopinionlabel: string;
  scocomment: string;
  scodate: string;
  scodecisioncode: string;
  scodecisioncodelabel: string;
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisiontype: string;
  scofreecomment: string;
  scogridid: number;
  scoid: number;
  scolabel: string;
  sconote: number;
  scoreference: string;
  scoringTabsList: Array<ScoringTabsResponse>;
  scoscore: string;
  scostatus: string;
  statuslabel: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  tprole: string;
  tprolelabel: string;
  updated_at: string;
  updated_by: number;
  usernamecreation: string;
}

export interface ScoringListSearch {
  clientname: string;
  clientreference: string;
  ctreference: string;
  propreference: string;
  scoanalystopinion: string;
  scodate: string;
  scodecisioncode: string;
  scodecisioncodelabel: string;
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisiontype: string;
  scogridid: string;
  scoid: string;
  scolabel: string;
  sconote: string;
  scoreference: string;
  scoscore: string;
  scostatus: string;
  scostatuslabel: string;
}

export interface ScoringTabsResponse {
  displaymode: string;
  scoid: number;
  scoringAttributeList: Array<ScoringAttributeResponse>;
  tabid: number;
  tablabel: string;
}

export interface ScoringView {
  created_at: string;
  created_by: number;
  objectid: number;
  objecttype: string;
  scoanalystopinion: string;
  scocomment: string;
  scodate: string;
  scodecisioncode: string;
  scodecisioncodelabel: string;
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisiontype: string;
  scofreecomment: string;
  scogridid: number;
  scoid: number;
  sconote: number;
  scoreference: string;
  scoscore: string;
  scostatus: string;
  tpid: number;
  tprole: string;
  updated_at: string;
  updated_by: number;
}

export interface ScoringViewResponse {
  created_at: string;
  created_by: number;
  objectid: number;
  objecttype: string;
  scoanalystopinion: string;
  scoanalystopinionlabel: string;
  scocomment: string;
  scodate: string;
  scodecisioncode: string;
  scodecisioncodelabel: string;
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisiontype: string;
  scofreecomment: string;
  scogridid: number;
  scogridlabel: string;
  referenceyear: string;
  scoid: number;
  sconote: number;
  scoreference: string;
  scoscore: string;
  scostatus: string;
  scostatuslabel: string;
  tpid: number;
  tprole: string;
  updated_at: string;
  updated_by: number;
  scoapprouvedamount:number;
}

export interface GetAttributeListByCriteriaParams {
  attcode: string;
  attdataorigin: string;
  attformula: string;
  attinputtype: string;
  attlabel: string;
  attservicename: string;
  objecttype: string;
  sqlfunction: string;
  tabtable: string;
}

export interface ParScoringResponse {
  applicationrule: string;
  scoexecutionmode: string;
  scoexecutionmodelabel: string;
  scoid: number;
  scolabel: string;
  scoobjecttype: string;
  scoobjecttypelabel: string;
  scostatus: string;
  scostatusdate: string;
  scostatususerid: number;
}

export interface ParScoringTabs {
  displaymode: string;
  scoid: number;
  tabid: number;
  tablabel: string;
  taborder: number;
}

export interface ParScoringAttEval {
  attdecision: string;
  attdecisioncomment: string;
  attdecisionlabel: string;
  attevaloperand: string;
  attnote: number;
  evallist: string;
  evalmax: string;
  evalmin: string;
  scoevalid: number;
  scolineid: number;
}

export interface ParScoringAttribute {
  actiontype: string;
  applicationrule: string;
  attcode: string;
  flagdisplay: boolean;
  scoid: number;
  scolineid: number;
  scolinelabel: string;
  scolineorder: number;
  tabid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary getAttributeListByCriteria
 */
export function getAttributeListByCriteria(
  params: GetAttributeListByCriteriaParams
) {
  return request.get<AbstractResponse<unknown, ParScoAttribute>>(
    `${URL}/api/attribute` +
      prepareQueryParams({
        attcode: params.attcode,
        attdataorigin: params.attdataorigin,
        attformula: params.attformula,
        attinputtype: params.attinputtype,
        attlabel: params.attlabel,
        attservicename: params.attservicename,
        objecttype: params.objecttype,
        sqlfunction: params.sqlfunction,
        tabtable: params.tabtable,
      } as any)
  );
}

export interface CreateAttributeParams {
  attRequest: ParScoAttribute;
}

/**
 * @tags Scoring Config Controller
 * @summary createAttribute
 */
export function createAttribute(params: CreateAttributeParams) {
  return request.post<AbstractResponse<ParScoAttribute, unknown>>(
    `${URL}/api/attribute`,
    params.attRequest
  );
}

export interface GetAttributeParams {
  attcode: string;
}

/**
 * @tags Scoring Config Controller
 * @summary getAttribute
 */
export function getAttribute(params: GetAttributeParams) {
  return request.get<AbstractResponse<ParScoAttribute, unknown>>(
    `${URL}/api/attribute/${params.attcode}`
  );
}

export interface UpdateAttributeParams {
  attRequest: ParScoAttribute;
  attcode: string;
}

/**
 * @tags Scoring Config Controller
 * @summary updateAttribute
 */
export function updateAttribute(params: UpdateAttributeParams) {
  return request.put<AbstractResponse<ParScoAttribute, unknown>>(
    `${URL}/api/attribute/${params.attcode}`,
    params.attRequest
  );
}

export interface GetParListScoringParams {
  parcode: string;
}

/**
 * @tags Scoring Config Controller
 * @summary getParListScoring
 */
export function getParListScoring(params: GetParListScoringParams) {
  return request.get<AbstractResponse<unknown, unknown>>(
    `${URL}/api/getParListScoring/${params.parcode}`
  );
}

export interface GetScoringListByCriteriaParams {
  clientname: string;
  clientreference: string;
  ctreference: string;
  scoreference: string;
  decisioncode: string;
  decisionlevel: string;
  decisiontype: string;
  propreference: string;
  status: string;
}

/**
 * @tags Scoring Engine Controller
 * @summary getScoringListByCriteria
 */
export function getScoringListByCriteria(
  params: GetScoringListByCriteriaParams
) {
  return request.get<AbstractResponse<unknown, ScoringListSearch>>(
    `${URL}/api/scoringFile` +
      prepareQueryParams({
        clientname: params.clientname,
        clientreference: params.clientreference,
        ctreference: params.ctreference,
        decisioncode: params.decisioncode,
        scoreference: params.scoreference,
        decisionlevel: params.decisionlevel,
        decisiontype: params.decisiontype,
        propreference: params.propreference,
        status: params.status,
      } as any)
  );
}

export interface CreateScoringFileParams {
  objectid: number;
  objecttype: string;
  objectreference: string;
  scogridid: number;
  tpid: number;
  tprole: string;
  referenceyear: string;
  currcode: string;
  requestedamount: number;
  tpname: string;
  tpreference: string;
}

/**
 * @tags Scoring Engine Controller
 * @summary createScoringFile
 */
export function createScoringFile(params: CreateScoringFileParams) {
  return request.post<AbstractResponse<ScoringFile, unknown>>(
    `${URL}/api/scoringFile` +
      prepareQueryParams({
        objectid: params.objectid,
        objecttype: params.objecttype,
        objectreference: params.objectreference,
        scogridid: params.scogridid,
        tpid: params.tpid,
        tprole: params.tprole,
        tpname: params.tpname,
        tpreference: params.tpreference,
        referenceyear: params.referenceyear,
        currcode: params.currcode,
        requestedamount: params.requestedamount,
      } as any)
  );
}

export interface GetScoringFileParams {
  scoid: number;
}

/**
 * @tags Scoring Engine Controller
 * @summary getScoringFile
 */
export function getScoringFile(params: GetScoringFileParams) {
  return request.get<AbstractResponse<ScoringFile, unknown>>(
    `${URL}/api/scoringFile/${params.scoid}`
  );
}

export interface UpdateScoringFileParams {
  scRequest: ScoringFile;
  scoid: number;
}

/**
 * @tags Scoring Engine Controller
 * @summary updateScoringFile
 */
export function updateScoringFile(params: UpdateScoringFileParams) {
  return request.put<AbstractResponse<ScoringFile, unknown>>(
    `${URL}/api/scoringFile/${params.scoid}`,
    params.scRequest
  );
}

export interface UpdateScoringStatusParams {
  scoid: number;
  scostatus: string;
}

/**
 * @tags Scoring Engine Controller
 * @summary updateScoringStatus
 */
export function updateScoringStatus(params: UpdateScoringStatusParams) {
  return request.put<AbstractResponse<ScoringFile, unknown>>(
    `${URL}/api/scoringFile/${params.scoid}/updateStatus/${params.scostatus}`
  );
}

export interface GetScoringFileListParams {
  objectid: number;
  objecttype: string;
}

/**
 * @tags Scoring Engine Controller
 * @summary getScoringFileList
 */
export function getScoringFileList(params: GetScoringFileListParams) {
  return request.get<AbstractResponse<unknown, ScoringViewResponse>>(
    `${URL}/api/scoringFileList` +
      prepareQueryParams({
        objectid: params.objectid,
        objecttype: params.objecttype,
      } as any)
  );
}

export interface GetScoringGridConfigListByCriteriaParams {
  objecttype: string;
  scolabel: string;
  scoexecutionmode: string;
  scoid: number;
  scostatus: string;
}

/**
 * @tags Scoring Config Controller
 * @summary getScoringGridConfigListByCriteria
 */
export function getScoringGridConfigListByCriteria(
  params: GetScoringGridConfigListByCriteriaParams
) {
  return request.get<AbstractResponse<unknown, ParScoringResponse>>(
    `${URL}/api/scoringGrid` +
      prepareQueryParams({
        objecttype: params.objecttype,
        scolabel: params.scolabel,
        scoexecutionmode: params.scoexecutionmode,
        scoid: params.scoid,
        scostatus: params.scostatus,
      } as any)
  );
}

export interface CreateScoringGridParams {
  gridRequest: ParScoring;
}

/**
 * @tags Scoring Config Controller
 * @summary createScoringGrid
 */
export function createScoringGrid(params: CreateScoringGridParams) {
  return request.post<AbstractResponse<ParScoring, unknown>>(
    `${URL}/api/scoringGrid`,
    params.gridRequest
  );
}

export interface GetScoringGridConfigParams {
  scoid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary getScoringGridConfig
 */
export function getScoringGridConfig(params: GetScoringGridConfigParams) {
  return request.get<AbstractResponse<ConfigParScoring, object>>(
    `${URL}/api/scoringGrid/${params.scoid}`
  );
}

export interface GetScoringGridListByCriteriaParams {
  objectid: number;
  objecttype: string;
}

/**
 * @tags Scoring Engine Controller
 * @summary getScoringGridListByCriteria
 */
export function getScoringGridListByCriteria(
  params: GetScoringGridListByCriteriaParams
) {
  return request.get<AbstractResponse<unknown, ParScoring>>(
    `${URL}/api/scoringGridList` +
      prepareQueryParams({
        objectid: params.objectid,
        objecttype: params.objecttype,
      } as any)
  );
}

/**
 * @tags Scoring Engine Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface UpdateScoringGridParams {
  gridRequest: ParScoring;
  scoid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGrid
 */
export function updateScoringGrid(params: UpdateScoringGridParams) {
  return request.put<AbstractResponse<ParScoring, object>>(
    `${URL}/api/scoringGrid/${params.scoid}`,
    params.gridRequest
  );
}

export interface UpdateScoringGridStatusParams {
  scoid: number;
  status: string;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridStatus
 */
export function updateScoringGridStatus(params: UpdateScoringGridStatusParams) {
  return request.put<AbstractResponse<ParScoring, object>>(
    `${URL}/api/scoringGrid/${params.scoid}/status/${params.status}`
  );
}

export interface AddScoringGridTabParams {
  tabRequest: ParScoringTabs;
}

/**
 * @tags Scoring Config Controller
 * @summary AddScoringGridTab
 */
export function AddScoringGridTab(params: AddScoringGridTabParams) {
  return request.post<AbstractResponse<ParScoringTabs, object>>(
    `${URL}/api/scoringGrid/tabs`,
    params.tabRequest
  );
}

export interface UpdateScoringGridTabParams {
  tabRequest: ParScoringTabs;
  tabid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridTab
 */
export function updateScoringGridTab(params: UpdateScoringGridTabParams) {
  return request.put<AbstractResponse<ParScoringTabs, object>>(
    `${URL}/api/scoringGrid/tabs/${params.tabid}`,
    params.tabRequest
  );
}

export interface ParScoringDecLevel {
  scodecisionlevel: string;
  scodecisionlevellabel: string;
  scodecisionlevelrule: string;
  scodeclevelid: number;
  scoid: number;
}

export interface ParScoringDecision {
  existrefuse: string;
  notemax: number;
  notemin: number;
  scodecid: number;
  scodecisioncode: string;
  scodecisionlabel: string;
  scodecisionscore: string;
  scoid: number;
  approuvedlimitperc: number;
}

export interface AddScoringGridlevelsParams {
  declevel: ParScoringDecLevel;
}

/**
 * @tags Scoring Config Controller
 * @summary AddScoringGridlevels
 */
export function AddScoringGridlevels(params: AddScoringGridlevelsParams) {
  return request.post<AbstractResponse<ParScoringDecLevel, object>>(
    `${URL}/api/scoringGrid/levels`,
    params.declevel
  );
}

export interface UpdateScoringGridlevelsParams {
  declevel: ParScoringDecLevel;
  scodeclevelid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridlevels
 */
export function updateScoringGridlevels(params: UpdateScoringGridlevelsParams) {
  return request.put<AbstractResponse<ParScoringDecLevel, object>>(
    `${URL}/api/scoringGrid/levels/${params.scodeclevelid}`,
    params.declevel
  );
}

export interface DeleteScoringGridlevelsParams {
  scodeclevelid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary DeleteScoringGridlevels
 */
export function DeleteScoringGridlevels(params: DeleteScoringGridlevelsParams) {
  return request.delete<AbstractResponse<ParScoringDecLevel, object>>(
    `${URL}/api/scoringGrid/levels/${params.scodeclevelid}`
  );
}

export interface AddScoringGridDecisionParams {
  decision: ParScoringDecision;
}

/**
 * @tags Scoring Config Controller
 * @summary AddScoringGridDecision
 */
export function AddScoringGridDecision(params: AddScoringGridDecisionParams) {
  return request.post<AbstractResponse<ParScoringDecision, object>>(
    `${URL}/api/scoringGrid/decision`,
    params.decision
  );
}

export interface UpdateScoringGridDecisionParams {
  decision: ParScoringDecision;
  scodecid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridDecision
 */
export function updateScoringGridDecision(
  params: UpdateScoringGridDecisionParams
) {
  return request.put<AbstractResponse<ParScoringDecision, object>>(
    `${URL}/api/scoringGrid/decision/${params.scodecid}`,
    params.decision
  );
}

export interface DeleteScoringGridDecisionParams {
  scodecid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary DeleteScoringGridDecision
 */
export function DeleteScoringGridDecision(
  params: DeleteScoringGridDecisionParams
) {
  return request.delete<AbstractResponse<ParScoringDecision, object>>(
    `${URL}/api/scoringGrid/decision/${params.scodecid}`
  );
}

export interface DeleteScoringGridTabParams {
  tabid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary DeleteScoringGridTab
 */
export function DeleteScoringGridTab(params: DeleteScoringGridTabParams) {
  return request.delete<AbstractResponse<ParScoringTabs, object>>(
    `${URL}/api/scoringGrid/tabs/${params.tabid}`
  );
}

export interface AddScoringGridattributesEvalParams {
  attdecision?: string;
  attdecisioncomment?: string;
  attdecisionlabel?: string;
  attevaloperand?: string;
  attnote?: number;
  evallist?: string;
  evalmax?: string;
  evalmin?: string;
  scoevalid?: number;
  scolineid?: number;
}

/**
 * @tags Scoring Config Controller
 * @summary AddScoringGridattributesEval
 */
export function AddScoringGridattributesEval(
  params: AddScoringGridattributesEvalParams
) {
  return request.post<AbstractResponse<ParScoringAttEval, object>>(
    `${URL}/api/scoringGrid/attributes/eval`,
    {
      attdecision: params.attdecision,
      attdecisioncomment: params.attdecisioncomment,
      attdecisionlabel: params.attdecisionlabel,
      attevaloperand: params.attevaloperand,
      attnote: params.attnote,
      evallist: params.evallist,
      evalmax: params.evalmax,
      evalmin: params.evalmin,
      scoevalid: params.scoevalid,
      scolineid: params.scolineid,
    }
  );
}

export interface UpdateScoringGridattributesEvalParams {
  evalRequest: ParScoringAttEval;
  scoevalid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridattributesEval
 */
export function updateScoringGridattributesEval(
  params: UpdateScoringGridattributesEvalParams
) {
  return request.put<AbstractResponse<ParScoringAttEval, object>>(
    `${URL}/api/scoringGrid/attributes/eval/${params.scoevalid}`,
    params.evalRequest
  );
}

export interface DeleteScoringGridattributesEvalParams {
  scoevalid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary deleteScoringGridattributesEval
 */
export function deleteScoringGridattributesEval(
  params: DeleteScoringGridattributesEvalParams
) {
  return request.delete<AbstractResponse<ParScoringAttribute, object>>(
    `${URL}/api/scoringGrid/attributes/eval/${params.scoevalid}`
  );
}

export interface DuplicateScoringGridParams {
  scoid: number;
  scolabel: string;
}

/**
 * @tags Scoring Config Controller
 * @summary duplicateScoringGrid
 */
export function duplicateScoringGrid(params: DuplicateScoringGridParams) {
  return request.post<AbstractResponse<ParScoring, object>>(
    `${URL}/api/scoringGrid/${params.scoid}/duplicate/${params.scolabel}`
  );
}

export interface AddScoringGridattributesParams {
  attRequest: ParScoringAttribute;
}

/**
 * @tags Scoring Config Controller
 * @summary addScoringGridattributes
 */
export function addScoringGridattributes(
  params: AddScoringGridattributesParams
) {
  return request.post<AbstractResponse<ParScoringAttribute, object>>(
    `${URL}/api/scoringGrid/attributes`,
    params.attRequest
  );
}

export interface UpdateScoringGridattributesParams {
  attRequest: ParScoringAttribute;
  scolineid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary updateScoringGridattributes
 */
export function updateScoringGridattributes(
  params: UpdateScoringGridattributesParams
) {
  return request.put<AbstractResponse<ParScoringAttribute, object>>(
    `${URL}/api/scoringGrid/attributes/${params.scolineid}`,
    params.attRequest
  );
}

export interface DeleteScoringGridattributesParams {
  scolineid: number;
}

/**
 * @tags Scoring Config Controller
 * @summary DeleteScoringGridattributes
 */
export function DeleteScoringGridattributes(
  params: DeleteScoringGridattributesParams
) {
  return request.delete<AbstractResponse<ParScoringAttribute, object>>(
    `${URL}/api/scoringGrid/attributes/${params.scolineid}`
  );
}

export interface GetLatestScoringFileParams {
  entity: string;
  entityid: number;
}

/**
 * @tags Scoring Engine Controller
 * @summary getLatestScoringFile
 */
export function getLatestScoringFile(params: GetLatestScoringFileParams) {
  return request.get<AbstractResponse<ScoringFile, object>>(
    `${URL}/api/latestScoringFile/${params.entity}/${params.entityid}`
  );
}
